import {required} from 'react-admin';

export const getFields = () => [
  {
    label: 'Name FR',
    source: 'labelFr',
  },
  {
    label: 'Name EN',
    source: 'labelEn',
  },
  {
    label: 'Document Type code',
    source: 'code',
  },
];

export const getInputs = () => [
  {
    label: 'Name FR',
    source: 'labelFr',
    validate: [required('The label FR is mandatory')],
  },
  {
    label: 'Name EN',
    source: 'labelEn',
    validate: [required('The label EN is mandatory')],
  },
  {
    label: 'Document Type code',
    source: 'code',
  },
];
